import React, { useState, useEffect } from "react"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper"
import TMHFormBase from "../../components/TMHForm/TMHFormBase"
import TMHFormInput from "../../components/TMHForm/TMHFormInput"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import TMHFooter from "../../components/TMHFooter/TMHFooter"
import validator from 'validator'
import config from "../../config.json"
import "./ForgotPasswordPage.css"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function ForgotPasswordPage() {
    useTitle("Forgot Password - The Movie House TV")
    useEffect(() => {
        ReactGA.send("pageview")
    })

    const [isLoading, setIsLoading] = useState(false)
    const [emailAddress, setEmailAddress] = useState("")
    const [errorText, setErrorText] = useState("")
    const [successText, setSuccessText] = useState("")

    async function handleSubmit(event) {
        event.preventDefault()
        setIsLoading(true)
        if (!validator.isEmail(emailAddress)) {
            setIsLoading(false)
            setErrorText("Email Field is Invalid")
            setSuccessText("")
            return
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "username": emailAddress
            }),
        };


        event.preventDefault();
        setIsLoading(true)
        setErrorText("")
        setSuccessText("")
        fetch(config.baseUrl + "forgot_password", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json
                    })))
            }).then(
                (result) => {
                    if (result.ok) {
                        setSuccessText(result.json.message)
                    }
                    else {
                        setErrorText(result.json.message)
                    }
                    setIsLoading(false)
                },
                (error) => {
                    console.log(error)
                    setErrorText(error.toString())
                    setSuccessText("")
                    setIsLoading(false)
                }
            )
    }

    return (
        <TMHBanner classOption="only-gradient" isLogged={false}>
            <TMHFormWrapper classOption="forgot-password-page-wrapper">
                <TMHFormBase onSubmit={handleSubmit} method="POST">
                    <div className="forgot-password-text">Forgot Password</div>
                    <div className="forgot-password-page-warning-text">
                        <div className="error-text">{errorText}</div>
                        <div className="success-text">{successText}</div>
                    </div>
                    <TMHFormInput
                        type="text"
                        placeholder="Email"
                        value={emailAddress}
                        onChange={({ target }) => setEmailAddress(target.value)}
                    />
                    <button type="submit" className="forgot-password-button">
                        <div className="forgot-password-reset-text">Reset password</div>
                    </button>
                </TMHFormBase>
                {isLoading && <TMHLoader />}
            </TMHFormWrapper>
            <TMHFooter />
        </TMHBanner>
    )
}
